import api from './api';

// YÖNETİM uçları (CN.Read / CN.Write). Çalışanın gördüğü menü okumaları
// myMealService.js'tedir — bkz. MyMealController.
export const getMealMenus = (params) => api.get('/v1/meal-menus', { params });
export const getMealMenu = (id) => api.get(`/v1/meal-menus/${id}`);
export const createMealMenu = (data) => api.post('/v1/meal-menus', data);
export const updateMealMenu = (id, data) => api.put(`/v1/meal-menus/${id}`, data);
export const deleteMealMenu = (id) => api.delete(`/v1/meal-menus/${id}`);
export const importMealMenus = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/v1/meal-menus/import', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const downloadMealMenuTemplate = () =>
  api.get('/v1/meal-menus/import-template', { responseType: 'blob' });
